
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M.744 13.125h3.631M17.407 2.298c-2.109 2.064-1.782 7.077-1.782 7.077v8.75s-1.25 1.25-5.625 1.25-5.625-1.25-5.625-1.25v-8.75s.327-5.013-1.783-7.077"}}),_c('path',{attrs:{"d":"M15.625 15.625h3.75l-.476-10a5.001 5.001 0 00-3.025-4.357L14.375.625S13.125 7.5 10 10C6.875 7.5 5.625.625 5.625.625l-1.5.643a5 5 0 00-3.024 4.357l-.476 10h3.75m14.881-2.5h-3.63M10 10v9.375"}}),_c('path',{attrs:{"d":"M5.625.625c1.32.8 2.83 1.232 4.375 1.25a8.641 8.641 0 004.375-1.25m-5 3.75h1.25"}})])])
          )
        }
      }
    